export default __webpack_public_path__ + "c5d7db2de99c8449763d5d3fa53450d1.svg";